export default __webpack_public_path__ + "static/media/ConnectMore.2dbd2879.png";